import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles.css'; // Global styles
import App from './App'; // Restore App import
import { ThemeProvider } from './contexts/ThemeContext';
// import reportWebVitals from './reportWebVitals'; // Optional: for performance measuring

const rootElement = document.getElementById('root');
if (!rootElement) throw new Error('Failed to find the root element');

const root = ReactDOM.createRoot(rootElement);

// Restore App render
root.render(
    <React.StrictMode>
        <ThemeProvider>
            <App />
        </ThemeProvider>
    </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals(); 